<section class="faq_section">
    <div class="container">
        <div class="questions text-lg-center text-md-center">
            <h2 class="faq_heading">FAQ’s Section</h2>
            <p style="color:#767473;">Frequently Asked QAs from Our Expert Educators
            </p>
        </div>
        <div class="m-auto mt-4 mb-4 col-lg-9">
            <ngb-accordion #acc="ngbAccordion" activeIds="config-panel-one">
                <ngb-panel title="How helpful are IIT JEE and NEET online coaching courses?">
                    <ng-template ngbPanelContent>
                        <p class="clr_gray faq_desc">Very helpful, if you are sincerely interested
                            in cracking these prestigious exams. Apart from expert guidance, you will
                            need to put in your sincere effort with complete determination to achieve
                            your goals. </p>
                    </ng-template>
                </ngb-panel>
                <ngb-panel title="What are the different study activities included in the courses? ">
                    <ng-template ngbPanelContent>
                        <p class="clr_gray faq_desc"> You will have access to live classes,
                            recorded lectures and test series. You will also receive specially
                            designed study materials from our academic experts and mentors.
                        </p>
                    </ng-template>
                </ngb-panel>
                <ngb-panel title=" What if I still have doubts about a particular subject or topic? ">
                    <ng-template ngbPanelContent>
                        <p class="clr_gray faq_desc">We have separate doubt-clearing sessions for this purpose.
                            Moreover, you will also have access to recorded lectures. </p>
                    </ng-template>
                </ngb-panel>
                <ngb-panel title=" What qualifications and experience do mentors and coaches at askIITians hold? ">
                    <ng-template ngbPanelContent>
                        <p class="clr_gray faq_desc">We are associated with ex-IITians and experts from engineering and
                            medical colleges for the coaching and study talks. We also get subject matter experts from
                            specific fields to meet our students' specific study needs.
                        </p>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</section>